import React, { useEffect } from 'react';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from './common/store/descarte.action';
import './descarte.style.css';
import Descarte from './tabs/descarte';
import Materiais from './tabs/materiais';
import Relatorios from './tabs/relatorios';
import { acessoPermitido } from '../../acessos.seguranca';
import * as acessos from '../../acessos.const.util';
import { useHistory } from 'react-router-dom';
import IntlMessage from '../../helpers/intlMessage';

function DescartePage () {
  const history = useHistory();
  const currentTab = useSelector(state => state.descarteCommon.tab);
  const usuario = useSelector(state => state.usuario);
  const dispatch = useDispatch();

  function verifyAcess () {
    const permissaoDescarteMateriais = acessoPermitido(usuario, acessos.DescarteMateriais);
    const permissaoConsultaDescarteMateriais = acessoPermitido(usuario, acessos.ConsultaDescarteMateriais);
    dispatch(actions.permissaoDescarteMateriais(permissaoDescarteMateriais));
    dispatch(actions.permissaoConsultaDescarteMateriais(permissaoConsultaDescarteMateriais));
    if (!permissaoConsultaDescarteMateriais) {
      history.push('/');
    }
  }

  useEffect(() => {
    verifyAcess();
    setTimeout(() => {
      dispatch(actions.atualizarTab('1'));
    }, 200);
  }, []);

  const mudarAba = (event, tab) => {
    dispatch(actions.atualizarTab(tab));
  };

  return (
    <div className='mv-descarte-page'>
      <TabContext value={currentTab}>
        <AppBar position='static' color='default'>
          <Tabs
            value={currentTab}
            onChange={mudarAba}
            variant='scrollable'
            //scrollButtons='on'
            indicatorColor='primary'
            textColor='primary'
            aria-label='scrollable force tabs example'
          >
            <Tab
              icon={<i className='tab-icons mv-basico-excluir'></i>}
              label={<IntlMessage id = "dashboards.disposalMaterials.general"/>}
              value='1'
            />
            <Tab
              icon={<i className='tab-icons mv-basico-retornar_situacao'></i>}
              label={<IntlMessage id = "dashboards.disposalMaterials.discardedMaterials"/>}
              value='2'
            />
            <Tab
              icon={
                <i className='tab-icons mv-basico-documento_eletronico'></i>
              }
              label={<IntlMessage id = "dashboards.disposalMaterials.reports"/>}
              value='3'
            />
            <Tab value='0' disabled></Tab>
          </Tabs>
        </AppBar>

        <TabPanel value='0'></TabPanel>
        <TabPanel value='1'>
          <Descarte />
        </TabPanel>
        <TabPanel value='2'>
          <Materiais />
        </TabPanel>
        <TabPanel value='3'>
          <Relatorios />
        </TabPanel>
      </TabContext>
    </div>
  );
}

export default DescartePage;



// WEBPACK FOOTER //
// ./src/pages/descarte/descarte.page.js